import { Component, EventEmitter, Input, Output } from '@angular/core'
import { Permissions } from 'src/app/core/enums/permissions.enum'

@Component({
  selector: 'app-history-mode',
  templateUrl: './history-mode.component.html',
  styleUrls: ['./history-mode.component.scss'],
  standalone: false,
})
export class HistoryModeComponent {
  @Input() isHistoryVisible: boolean = false
  @Output() historyToggled = new EventEmitter<void>()
}
